import PropTypes from "prop-types";
import useReferenceLogos from "../hooks/useReferenceLogos";

const Landing4th = ({ locale }) => {
    const { resolveLogos }  = useReferenceLogos();

    return (
        <div className='landing-element-container' id="landing-page-references">
            <div className='landing-element-content'>
                <div className="row">
                    <div className='col-lg-6 col-md-8 col-xs-12'>
                        <h1>{locale.title}</h1>
                        <p>{locale.subtitle}</p>
                    </div>
                </div>
                <div className="row landing-element-card-row g-0">
                    {resolveLogos().map(logo => (
                        <div key={`logo-${logo.src}`} className='col-md-2 col-4'>
                            <div className="card landing reference">
                                <img
                                    loading='lazy'
                                    src={logo.src}
                                    alt={logo.alt}
                                    className="img-fluid"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

Landing4th.propTypes = {
    locale: PropTypes.object.isRequired
}

export default Landing4th;
